export let ChartColors = {
  genereratedII: '#105567',
  genereratedIII: '#105567',
  active: '#105567',
  total: '#3ab0a9',
};



